/* ==========================================================================
   prinsert-menu-search.js
   --------------------------------------------------------------------------
   Zwei Dinge rund um die Navigation:

     1. Suchfeld in langen Menue-Listen (Spiele-Liste)
     2. Fester Sprungpunkt "#bewertungen" fuer den Link in der
        Ankuendigungsleiste

   ==========================================================================
   1) MENUE-SUCHE

   ZWEI MARKUP-VARIANTEN: Dawn nutzt fuer Desktop und Mobil voellig
   unterschiedliche Menues.
     Desktop: .header__inline-menu .header__submenu   (Dropdown)
     Mobil:   .menu-drawer__submenu .menu-drawer__menu (Schublade)
   Beide werden hier bedient. Wer nur den Desktop-Selektor setzt, sieht
   auf dem Handy nichts -- das Dropdown existiert dort schlicht nicht.

   AUSWAHL UEBER DIE ANZAHL: Nur Listen ab MIN_ITEMS Eintraegen bekommen
   ein Suchfeld -- dieselbe Schwelle wie beim mehrspaltigen Dropdown in
   prinsert-custom.css, Abschnitt 9. Beide Werte gehoeren zusammen.

   WARUM TEILSTRING UND NICHT "BEGINNT MIT":
   Flossenschlag, Fluegelschlag und Schwingenschlag unterscheiden sich erst
   am Wortende. Eine Suche nach "schlag" muss alle drei finden.

   NORMALISIERUNG: Gross-/Kleinschreibung, Umlaute und ss werden
   vereinheitlicht. "fluegel", "Flügel" und "FLUGEL" finden denselben
   Eintrag.

   ==========================================================================
   2) SPRUNGPUNKT FUER DIE BEWERTUNGEN

   Die Ankuendigungsleiste verlinkt auf /#bewertungen. Ein Element mit
   dieser Kennung gibt es im Markup aber nicht -- also setzt dieses Skript
   es vor den Bewertungsblock.

   WARUM NICHT EINFACH DIE SEKTIONS-ID VERLINKEN:
   Shopify vergibt Sektionen Kennungen der Form
       shopify-section-template--27149648888181__1786966097b3b40ad5
   Der mittlere Teil gehoert zur VORLAGE und aendert sich, sobald das
   Theme kopiert wird. Nach jedem Veroeffentlichen haette der Link also
   still ins Leere gefuehrt -- genau das ist einmal passiert, bevor diese
   Loesung entstand. Ein selbst gesetzter Anker kennt dieses Problem
   nicht.

   WIE DER BLOCK GEFUNDEN WIRD: ueber Teiltreffer im Klassennamen der
   Judge.me-App, nicht ueber die Sektions-ID. Bevorzugt das Karussell
   ("carousel"); gibt es das nicht, der letzte Judge.me-Block auf der
   Seite. Auf der Startseite stehen naemlich ZWEI davon -- die kleine
   Sternenzeile oben und die Kundenstimmen weiter unten. Gemeint sind die
   Kundenstimmen.

   DER BEOBACHTER IST NOETIG, weil die App ihren Block nachtraeglich
   einsetzt: Beim Auftreffen von DOMContentLoaded ist oft noch nichts da.
   Er endet nach dem ersten Treffer beziehungsweise nach 10 Sekunden --
   ein dauerhaft laufender Beobachter waere Verschwendung.
   ========================================================================== */

(function () {
  if (window.__prinsertMenuSearchInit) return;
  window.__prinsertMenuSearchInit = true;

  var MIN_ITEMS = 12;
  var ANKER_ID = 'bewertungen';

  var SELECTORS = [
    '.header__inline-menu .header__submenu',
    '.menu-drawer__submenu .menu-drawer__menu'
  ];

  function normalize(value) {
    return (value || '')
      .toLowerCase()
      .replace(/\u00df/g, 'ss')
      .replace(/\u00e4/g, 'ae')
      .replace(/\u00f6/g, 'oe')
      .replace(/\u00fc/g, 'ue')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  /* "Fluegelschlag" soll auch bei Eingabe von "flugelschlag" gefunden
     werden. Deshalb zusaetzlich eine Variante ohne das eingefuegte e. */
  function collapseUmlautE(value) {
    return value.replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
  }

  function setup(list) {
    if (list.dataset.prinsertSearch) return;

    var items = Array.prototype.filter.call(list.children, function (el) {
      return el.tagName === 'LI';
    });
    if (items.length < MIN_ITEMS) return;

    list.dataset.prinsertSearch = '1';
    list.classList.add('has-menu-search');

    var isDrawer = !!list.closest('.menu-drawer__submenu');

    var searchItem = document.createElement('li');
    searchItem.className = 'prinsert-menu-search';
    if (isDrawer) searchItem.classList.add('prinsert-menu-search--drawer');

    var input = document.createElement('input');
    input.type = 'search';
    input.className = 'prinsert-menu-search__input';
    input.placeholder = 'Spiel suchen \u2026';
    input.setAttribute('aria-label', 'Spiel suchen');
    input.setAttribute('autocomplete', 'off');
    searchItem.appendChild(input);

    var emptyItem = document.createElement('li');
    emptyItem.className = 'prinsert-menu-search__empty is-hidden';
    emptyItem.textContent = 'Kein Spiel gefunden.';

    list.insertBefore(searchItem, list.firstChild);
    list.appendChild(emptyItem);

    var entries = items.map(function (li) {
      var plain = normalize(li.textContent);
      return {
        li: li,
        haystacks: [plain, collapseUmlautE(plain)]
      };
    });

    function matches(entry, tokens) {
      return tokens.every(function (token) {
        var loose = collapseUmlautE(token);
        return entry.haystacks.some(function (hay) {
          return hay.indexOf(token) !== -1 || hay.indexOf(loose) !== -1;
        });
      });
    }

    function apply() {
      var query = normalize(input.value);
      var tokens = query ? query.split(/\s+/) : [];
      var visible = 0;

      entries.forEach(function (entry, index) {
        var show;
        if (tokens.length === 0) {
          show = true;
        } else if (index === 0) {
          /* "Alle Spiele" ist ein Navigationspunkt, kein Spiel -- waehrend
             einer Suche wuerde er als falscher Treffer wirken. */
          show = false;
        } else {
          show = matches(entry, tokens);
        }
        entry.li.classList.toggle('is-hidden', !show);
        if (show) visible += 1;
      });

      emptyItem.classList.toggle('is-hidden', visible > 0);
    }

    input.addEventListener('input', apply);

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (input.value) {
          /* Erst die Eingabe leeren, erst beim zweiten Escape das Menue
             schliessen lassen. */
          event.stopPropagation();
          input.value = '';
          apply();
        }
        return;
      }
      if (event.key === 'Enter') {
        event.preventDefault();
        var link = list.querySelector('li:not(.is-hidden):not(.prinsert-menu-search) a');
        if (link && link.href) window.location.href = link.href;
      }
    });

    /* Ein Klick ins Suchfeld darf das Menue nicht schliessen. */
    searchItem.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    var details = list.closest('details');
    if (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        input.value = '';
        apply();
        /* Fokus nur mit echter Maus/Tastatur setzen. Auf Touch wuerde sonst
           die Bildschirmtastatur aufspringen und das halbe Menue verdecken. */
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          setTimeout(function () {
            input.focus();
          }, 40);
        }
      });
    }
  }

  /* ------------------------------------------------------------------
     Sprungpunkt fuer die Bewertungen -- siehe Dateikopf, Abschnitt 2.
     ------------------------------------------------------------------ */
  function setzeBewertungsAnker() {
    if (document.getElementById(ANKER_ID)) return true;

    /* Bevorzugt das Karussell mit den Kundenstimmen. Die kleine
       Sternenzeile weiter oben ist ebenfalls ein Judge.me-Block --
       deshalb erst der gezielte Griff, dann der letzte als Rueckfall. */
    var treffer = document.querySelector('.shopify-section [class*="jdgm-"][class*="carousel"]');

    if (!treffer) {
      var alle = document.querySelectorAll('.shopify-section [class*="jdgm-"]');
      if (alle.length > 0) treffer = alle[alle.length - 1];
    }

    if (!treffer) return false;

    var sektion = treffer.closest('.shopify-section');
    if (!sektion || !sektion.parentNode) return false;

    var anker = document.createElement('span');
    anker.id = ANKER_ID;
    anker.setAttribute('aria-hidden', 'true');
    anker.style.display = 'block';
    /* Abstand nach oben, damit die Ueberschrift nicht unter der
       mitscrollenden Kopfzeile verschwindet. */
    anker.style.scrollMarginTop = '10rem';

    sektion.parentNode.insertBefore(anker, sektion);

    /* Wurde die Seite MIT #bewertungen aufgerufen, hat der Browser den
       Sprung laengst versucht -- damals gab es das Ziel noch nicht.
       Deshalb hier nachholen. */
    if (window.location.hash === '#' + ANKER_ID) {
      anker.scrollIntoView();
    }

    return true;
  }

  function beobachteBewertungen() {
    if (setzeBewertungsAnker()) return;

    var beobachter = new MutationObserver(function () {
      if (setzeBewertungsAnker()) beobachter.disconnect();
    });

    beobachter.observe(document.body, { childList: true, subtree: true });

    /* Nicht ewig warten: Gibt es auf dieser Seite keinen
       Bewertungsblock, waere ein dauerhaft laufender Beobachter reine
       Verschwendung. */
    setTimeout(function () {
      beobachter.disconnect();
    }, 10000);
  }

  function init() {
    SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(setup);
    });

    beobachteBewertungen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
